import { Component, OnInit } from '@angular/core';
import { OccupationService } from '../occupation.service';
import { Occupation } from '../occupation';
import { Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-occupation-create',
  templateUrl: 'create.component.html',
})
export class OccupationCreateComponent implements OnInit {
  /**
   * Details of the occupation being created.
   */
  public occupation: Occupation;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {OccupationService} occupationService
   * @param {NotificationService} notificationService
   * @param {Router} router
   */
  constructor(
    private occupationService: OccupationService,
    private notificationService: NotificationService,
    private router: Router,
  ) {
    this.occupationService.loading.subscribe(
      result => (this.isLoading = result),
    );
  }

  /**
   * Initialise the component, creating a new blank occupation if required.
   */
  public ngOnInit(): void {
    if (!this.occupation) {
      this.occupation = new Occupation();
    }
  }

  /**
   * Perform the create action which adds the new occupation into the backend.
   */
  public create() {
    const createOccupation = this.occupationService
      .createOccupation(this.occupation)
      .subscribe(
        (result: Occupation) => {
          this.notificationService.success(
            `Occupation Created`,
            `New occupation ${result.name} has been created with ID of ${
              result.id
            }.`,
            5,
          );
          this.occupation = new Occupation();
          createOccupation.unsubscribe();
          this.router.navigate(['/occupations']);
        },
        err => {
          this.notificationService.error(
            `Could not create Occupation`,
            err.error.message,
            10,
          );
        },
      );
  }
}
